// extracted by css-extract-rspack-plugin
export default {"BillTermsAndConditionsPrompt":"sputnik__BillTermsAndConditionsPrompt__HzxfI","billTermsAndConditionsPrompt":"sputnik__BillTermsAndConditionsPrompt__HzxfI"};